module.exports = __webpack_public_path__ + "img/sc5_002.412c5780.png";